import { ComplextRoute } from 'router/components/Routes/Routes';
import CreateDealRoom from './pages/CreateDealRoom';
import { UploadImSuccessfulPage } from '../pages/UploadImSuccessful';

export default [
  {
    index: true,
    element: CreateDealRoom,
  },
  {
    path: 'im-upload-successful',
    element: UploadImSuccessfulPage,
  },
] as Array<ComplextRoute>;
